import { SpliteButton } from "@/components";
import { useDesignMaxTheme } from "@/packages";
import { FONT } from "@/styles";
import { Box, Flex, Text } from "@chakra-ui/react";
import { type RoomListType } from "../../../otherRoomPreview/otherRoomPreview.type";

export const RoomPhoto = ({ room }: { room: RoomListType }) => {
    const { MEDIAS } = useDesignMaxTheme();
    const { isTablet, isMobile } = MEDIAS();

    return (
        <Flex
            position="relative"
            maxW="1024px !important"
            w="100%"
            minHeight={isMobile ? "none" : "970px"}
            alignItems="flex-end"
            flexDir={isMobile ? "column-reverse" : "row"}
        >
            <Flex
                position={isMobile ? "relative" : "absolute"}
                top="0"
                w="100%"
                justifyContent="flex-end"
                pl={isMobile ? "16px" : "0"}
            >
                <Box
                    w={isMobile ? "100%" : "504px"}
                    h={isMobile ? "256px" : "686px"}
                    overflow="hidden"
                    borderTopRightRadius={isMobile ? "40px" : "88px"}
                    background={room.imgList[2] ? `url(${room.imgList[2].img_URL})no-repeat center/cover` : "gray.100"}
                />
            </Flex>

            <Flex w="100%" flexDir="column" zIndex="2">
                <Flex
                    w="100%"
                    h={isMobile ? "64px" : "126px"}
                    p={isMobile ? "0 24px" : "0 48px"}
                    alignItems="center"
                    justifyContent={isMobile ? "flex-end" : "flex-start"}
                >
                    <Text color="#F5F3EF" {...FONT("cormorant", isMobile ? 40 : 104, 700, 1.2)}>
                        ROOMS
                    </Text>
                </Flex>
                <Flex alignItems="flex-end" display={isTablet ? "none" : "flex"}>
                    <Box
                        overflow="hidden"
                        maxW="728px"
                        w="100%"
                        h="576px"
                        borderBottomRightRadius="88px"
                        background={
                            room.imgList[1] ? `url(${room.imgList[1].img_URL})no-repeat center/cover` : "gray.100"
                        }
                    />
                    {!isMobile && (
                        <Box mb="80px">
                            <SpliteButton text="MoreView" />
                        </Box>
                    )}
                </Flex>
            </Flex>
        </Flex>
    );
};
